export const CHECKOUT_URL = 'https://spanish-teacher-pro.impultienda.ar/checkout'

export const BUY_ANCHOR = 'buy'

export const PRODUCT_NAME = 'SPANISH TEACHER PRO™'

export const CTA_LABEL = 'GET SPANISH TEACHER PRO™ NOW'

export const SUPPORT_EMAIL = 'kitonline27@gmail.com'

export function scrollToBuy(): void {
  const el = document.getElementById(BUY_ANCHOR)
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }
}

export const IMAGES = {
  system:
    'https://cdn.magicpatterns.com/uploads/pvNYGeiNqo4E8rs8QqDfnJ/ChatGPT-Image-25-ago-2026_-08_25_50-p.m..webp',
}
